import { render } from "./SlidebarAdmin.vue?vue&type=template&id=4d1f5dea&scoped=true&ts=true"
import script from "./SlidebarAdmin.vue?vue&type=script&lang=ts"
export * from "./SlidebarAdmin.vue?vue&type=script&lang=ts"

import "../assets/scss/component/slidebar.scss?vue&type=style&index=0&id=4d1f5dea&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/dev.poct.nikted.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1f5dea"]])

export default __exports__